import Model from './model.js';
import Employee from './employee.js';

export default class LeaveApproval extends Model {
    urlRoot() { return '/LeaveApprovals'; }

    defaults() {
        return {
            layer: 1
        };
    }

    constructor() {
        super(...arguments);
        this.softDelete = false;
        this.requester = null;
        this.approver = null;
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
    }

    constraints() {
        return {
            requesterId: {presence: true},
            approverId: {presence: true},
            layer: {presence: true}
        };
    }

    fetchRequester() {
        if (this.requester) {
            Promise.resolve(this.requester);
        }

        const employee = app.employees.find(
            emp => emp.get('objectId') === this.get('requesterId')
        );
        if (employee) {
            this.requester = employee;
            return Promise.resolve(employee);
        }

        return new Employee(
            {objectId: this.get('requesterId')}
        )
        .fetch({validate: false})
        .then(model => {
            this.requester = model;
            return this.requester;
        })
        .catch(() => null);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/leave-approval.js